export default "__VITE_ASSET__a9a77dcd__"